// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2wczF","box":"WorkspacesBox_box__2JPGg","node":"WorkspacesBox_node__3pREW"};